import { useEffect } from 'react'

export function useMobileTouchHandler(
  isMobileDevice: boolean,
  isAtBottom: boolean,
  isChatInputFocused: boolean,
) {
  useEffect(() => {
    if (isMobileDevice && isAtBottom) {
      let startY: number | null = null

      const handleTouchStart = (event: TouchEvent) => {
        startY = event.touches[0].clientY
      }

      const handleTouchMove = (event: TouchEvent) => {
        if (startY === null) return

        const currentY = event.touches[0].clientY

        const isMovingUp = currentY > startY

        if (!isMovingUp && isChatInputFocused) {
          event.preventDefault()
        }
      }

      document.addEventListener('touchstart', handleTouchStart)

      document.addEventListener('touchmove', handleTouchMove, {
        passive: false,
      })

      return () => {
        document.removeEventListener('touchstart', handleTouchStart)

        document.removeEventListener('touchmove', handleTouchMove)
      }
    }
  }, [isMobileDevice, isAtBottom, isChatInputFocused])
}
